import React from 'react';
import Skeleton from 'antd/lib/skeleton';
import Table from 'antd/lib/table';

const emptyRows = [...new Array(4)].map((_, index) => ({ id: index }));

const renderCell = width => (
  <Skeleton
    active
    title={{ width }}
    paragraph={false}
  />
);

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: () => renderCell('60%'),
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    render: () => renderCell('80%'),
  },
  {
    title: 'Locations',
    dataIndex: 'locations',
    key: 'locations',
    render: () => renderCell('40%'),
  },
  {
    title: 'Boundaries',
    dataIndex: 'boundaries',
    key: 'boundaries',
    render: () => renderCell('85%'),
  },
  {
    title: 'Datasets',
    dataIndex: 'datasets',
    key: 'datasets',
    render: () => renderCell('70%'),
  },
  {
    title: 'Last Updated',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: () => renderCell('55%'),
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    render: () => renderCell('45%'),
  },
];

const SkeletonTable = () => (
  <Table
    columns={columns}
    dataSource={emptyRows}
    pagination={false}
    rowKey="id"
  />
);

export default SkeletonTable;
